import {clsx} from 'clsx'

import styles from './SuspenseFallback.module.css'
import {FileUploadButton} from './toolbar/FileUploadButton'
import {Header} from './toolbar/Header'
import {Toolbar} from './toolbar/Toolbar'
import type {HybridMarkdownEditorProps} from './types'

type SuspenseFallbackProps = Pick<HybridMarkdownEditorProps, 'value' | 'placeholder'>

export function SuspenseFallback({value, placeholder}: SuspenseFallbackProps) {
  return (
    <>
      <Header selectedView="hybrid">
        <Toolbar view={null} selectedNodes={[]} fileUploadButton={<FileUploadButton disabled />} />
      </Header>

      <div className={clsx('cm-editor', 'cm-content', styles.container)}>
        {value || <div className={styles.placeholder}>{placeholder}</div>}
      </div>
    </>
  )
}

try{ SuspenseFallback.displayName ||= 'SuspenseFallback' } catch {}